import React from "react";
import bannerImage from "../../assets/images/home/homePageWelcomeBanner.webp";
import "./index.css";

export const BannerSection = () => {
  return (
    <div className="homeBanner">
      <div className="homeBannerContent">
        <h1>A Private Space to Share, Listen & Heal.</h1>
        <p>
          Real conversations with trained listeners, fully private and designed
          for your emotional well-being.
        </p>
        <a href={`${process.env.REACT_APP_LISTENAURA_APP_URL}`} target="_blank"><button>Start Your Session</button></a>
        <img src={bannerImage} alt="Welcome" />
      </div>
    </div>
  );
};
